import { render, staticRenderFns } from "./new.html-blocks.page.vue?vue&type=template&id=11d27ff4&"
import script from "./new.html-blocks.page.vue?vue&type=script&lang=js&"
export * from "./new.html-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports